<h2>NS2200 (NS: 1957 - 2003)</h2>

<apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [fill]="chartOptions.fill"
  [grid]="chartOptions.grid" [dataLabels]="chartOptions.dataLabels" [plotOptions]="chartOptions.plotOptions"
  [xaxis]="chartOptions.xaxis" [yaxis]="chartOptions.yaxis" [title]="chartOptions.title"
  [tooltip]="chartOptions.tooltip"></apx-chart>

<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Overzicht
      </mat-panel-title>
      <mat-panel-description>
        Mijlpalen van de inzet NS2200
      </mat-panel-description>
    </mat-expansion-panel-header>

    <ul>
      <li>1955-1958: In dienst</li>
      <li>In 1959 worden de 2201 - 2225 voorzien van een derde frontsein</li>
      <li>Begin ’60: Installatie geluidsdemper</li>
      <li>1963 werd het L sein ingevoerd</li>
      <li>1967+: Installatie blauw zwaailicht</li>
      <li>1971(+): een deel overgeschilderd in de nieuwe huisstijl kleuren geel-grijs</li>
      <li>In 1984 worden alle blauwe zwaailichten op de locomotieven vervangen door rode zwaailichten.</li>
      <li>1995: NS Cargo rood (1 exemplaar)</li>
      <li>2003: Laatste buiten dienst</li>
    </ul>

    <h4>Bronnen:</h4>
    <p><a href="https://nl.wikipedia.org/wiki/NS_2200" target="_blank">
        <mat-icon [inline]="true">open_in_new</mat-icon>Wikipedia
      </a><br />
      <a href="https://www.bentinkmodelspoor.nl/content/84-de-piko-ns2200-super-model" target="_blank">
        <mat-icon [inline]="true">open_in_new</mat-icon>Bentink Modelspoor
      </a><br />
      <a href="https://www.railwiki.nl/index.php/2200/2300_-_Diesel_locomotieven_serie_2200/2300" target="_blank">
        <mat-icon [inline]="true">open_in_new</mat-icon>Rrailwiki.nl
      </a>

  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Modellen
      </mat-panel-title>
      <mat-panel-description>
        Schaal N modellen
      </mat-panel-description>
    </mat-expansion-panel-header>


    <h4>Piko 40440 NS Dieselloc 2297 Bruin</h4>
    <ul>
      <li>1957: NS2297 in dienst</li>
      <li>1962(+/-): Geen geluidsdemper op model</li>
    </ul>

    <h4>Piko 40418 NS Dieselloc 2218 Bruin, A-licht</h4>
    <ul>
      <li>1959+: Derde frontsein</li>
      <li>1981: Na ongeluk gesloopt(?)</li>
    </ul>

    <h4>Piko 40443 NS Dieselloc 2271 Bruin, Blauwe zwaailichten</h4>
    <ul>
      <li>1970: Installatie zwaailicht
      </li>
      <li>
        tot 1984: Vervanging zwaailicht blauw --> rood
      </li>
    </ul>

    <h4>Piko 40444 NS Dieselloc 2207 Geel/Grijs, Rode zwaailichten</h4>
    <ul>
      <li>1984: Rood zwaailicht</li>
      <li>2003: Terzijde / Niet gesloopt: naar VSM</li>
    </ul>

    <h4>Piko 40442 NS Dieselloc 2342 Geel/Grijs 3A Licht</h4>
    <ul>
      <li>1984: Rood zwaailicht</li>
      <li>2003: Terzijde, 2004 gesloopt</li>
    </ul>

    <h4>Piko 40441 NS Dieselloc 2384 Rood</h4>
    <ul>
      <li>1995: NS Cargo rood</li>
      <li>2003: Terzijde / Gesloopt</li>
    </ul>

  </mat-expansion-panel>

</mat-accordion>
